import ko from 'knockout';
import _ from 'underscore';

export function staticControl(local, attrs, fieldOption) {
  const { valueMessages, values } = fieldOption;
  const stringValueObservable = local.string ? local.string : local;

  _.extend(local, {
    static: values ?
      ko.computed(() => valueMessages[_.indexOf(values, local())]) :
      stringValueObservable,
  });
}
